export default ([
  {
    label   : 'Date of Admission',
    itemKey : 'admissionDate',
    decoder : 'formatDate'
  },
  {
    label   : 'Pregnancy Type' ,
    itemKey : 'pregnancyType',
    decoder : 'decodePregnancyType'
  },
  {
    label   : 'Abortion Type' ,
    itemKey : 'abortionType',
    decoder : 'decodeAbortionType'
  },
  {
    label   : 'Ectopic Pregnancy Type' ,
    itemKey : 'ectopicType',
    decoder : 'decodeEctopicType'
  },
  {
    label   : 'Molar Type' ,
    itemKey : 'molarType',
    decoder : 'decodeMolarType'
  },
  {
    label   : 'Delivery Date',
    itemKey : 'deliveryDate',
    decoder : 'formatDate'
  },
  {
    label   : 'Manner of Delivery',
    itemKey : 'deliveryManner',
    decoder : 'decodeDeliveryManner'
  },
  {
    label   : 'Gyne Diagnosis',
    itemKey : 'gynecologicalDiagnosis',
    decoder : 'decodeGyneCondition'
  },
  {
    label   : 'Discharge Date',
    itemKey : 'dischargeDate',
    decoder : 'formatDate'
  },
  {
    label   : 'Mother Condition' ,
    itemKey : 'motherCondition',
    decoder : 'decodeMotherCondition'
  }
])
